<template>
  <div class="disciplines">
    <el-table :data="disciplinesData" style="width: 100%">
      <el-table-column
        prop="semester"
        :label="!mobileMode ? 'Семестр' : ''"
        :width="mobileMode ? '40' : '90'"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        label="Название"
        width="auto"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      disciplinesData: [],
    };
  },

  watch: {
    groupId() {
      this.fetchData()
    }
  },

  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    rebuildingData(data) {
      return Object.keys(data).reduce((acc, key)=> {
        data[key].forEach(title => {
          acc.push({ semester: key, title })
        });
        return acc
      }, []);
    },

    async fetchData() {
      try {
        const { data: { discipline }, status } = await this.axios.get(`api/journal/presence/${this.$route.params.sid}/disciplines/${this.groupId}`);

        if (status === 200) {
          this.disciplinesData = this.rebuildingData(discipline);
        }
      } catch(e) {
        console.warn('Error fetch [Presence/disciplineList]', e)
      }
    }
  }
};
</script>
